<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img :src="require('@/assets/images/banner.png')" style="width: 200px">
      </b-link>
      <!-- /Brand logo-->


      <!-- Login-->
      <b-col
        lg="4" style="margin: 0px auto"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            انشاء حساب جديد
          </b-card-title>
          <b-card-text class="mb-2">
            قم بانشاء حساب جديد في المنصة مجاناً
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="الاسم"
                label-for="login-emailx"
              >
                <validation-provider
                  #default="{ errors }"
                  name="الاسم"
                  rules="required"
                >
                  <b-form-input size="lg"
                    id="login-emailx"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    name="login-emailx"
                    placeholder="اكتب هنا..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email -->
              <b-form-group
                label="رقم الجوال (يكون عليه واتسآب)"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="رقم الجوال"
                  rules="required"
                >
                  <b-form-input size="lg"
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="اكتب هنا..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input size="lg"
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="اكتب هنا..."
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div class="g">
                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="validationForm"
                >
                  انشاء حساب الآن
                </b-button>
              </div>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{name:'login'}">
              <span>&nbsp;تسجيل الدخول</span>
            </b-link>
          </b-card-text>
          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
            </div>
          </div>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      name: '',
      sideImg: require('@/assets/images/login.jpg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    changeLang(l){
      localStorage.setItem('lang', l);
      location.reload()
    },
    validationForm() {
      var g = this;
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          $.post(api + '/user/auth/register', {
            phone: g.userEmail,
            password: g.password,
            name: g.name,
            lang: localStorage.getItem('lang')
          }).then(function(r){
            if(r.status == 100){
              window.location = '/activate?token=' + r.response;
            }else{
              g.$toast({
                component: ToastificationContent,
                props: {
                  title: r.response,
                  icon: 'EditIcon',
                  variant: 'danger',
                },
              })
            }
          }).fail(function(){
            g.$toast({
                component: ToastificationContent,
                props: {
                  title: lang("error"),
                  icon: 'EditIcon',
                  variant: 'danger',
                },
              })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.d-none.d-lg-flex.align-items-center.p-5.col-lg-8{
  background: #e7e7e7;
}
</style>
